import type { MapSelectionMode } from '../map'
import { mapAtom } from '../map'

export const setMapSelectionMode = (mode: MapSelectionMode) => {
  mapAtom.selectionMode = mode
}
